import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import "react-chat-widget/lib/styles.css";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

export default function SupportWidget({ actionHandle, open }) {
  return (
    <Box className="rcw-widget-container rcw-close-widget-container ">
      <Button
        onClick={() =>
          window.open(
            "https://api.whatsapp.com/send?phone=971508595568&text=Hello%2C%20I%20need%20help%20with%20managing%20my%20Deliverit%20store.%20Could%20you%20please%20assist%20me%3F",
            "_blank"
          )
        }
        type="button"
        className="rcw-launcher chat-button"
        aria-controls="rcw-chat-container"
      >
        <SupportAgentIcon style={{ fontSize: "50px" }} />
      </Button>
    </Box>
  );
}
